import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { yowanRouteManifest } from '../routes/manifest';
import YowanFooter from './YowanFooter';
import YowanHeader from './YowanHeader';
import { YowanAuthProvider } from './YowanAuthContext';

const buildNavigationItems = () =>
  yowanRouteManifest
    .filter((route) => Boolean(route.navLabel))
    .map((route) => ({
      path: route.path,
      navLabel: route.navLabel,
    }));

const YowanShell = ({ children }) => {
  const { pathname } = useLocation();
  const navigationItems = buildNavigationItems();
  const isManagementRoute = pathname.startsWith('/admin') || pathname.startsWith('/stakeholder');
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [showFloatingMenu, setShowFloatingMenu] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const handleScroll = () => {
      setShowFloatingMenu(window.scrollY > 240);
      setShowBackToTop(window.scrollY > 560);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleBackToTop = () => {
    if (typeof window === 'undefined') {
      return;
    }

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div className="yowan-theme yowan-shell">
      <div className="yowan-shell__backdrop" aria-hidden="true" />
      <YowanAuthProvider>
        <YowanHeader
          navigationItems={navigationItems}
          floatingMenuActive={showFloatingMenu && !isManagementRoute}
        />
        <div className={`yowan-shell__main${isManagementRoute ? ' yowan-shell__main--admin' : ''}`}>{children}</div>
      </YowanAuthProvider>
      <button
        type="button"
        className={`yowan-shell__back-to-top${showBackToTop ? ' is-visible' : ''}`}
        aria-label="ページ上部へ戻る"
        onClick={handleBackToTop}
      >
        <span aria-hidden="true">↑</span>
      </button>
      <YowanFooter />
    </div>
  );
};

export default YowanShell;
